<div>
    <ng-template #excelPdfPopup>
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelReportPopup()" mat-button>
            <i class="fa popupClose">&#xf00d;</i>
        </button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div style="margin: 15px 15px;" class="center">
            <label for="email" style="font-size: medium; font-weight: bold;">
                Do you want to generate {{ popupDataTitle.title }} ?</label>
        </div>
        <div style="margin: 15px 15px;" class="center" *ngIf="!isForExcel">
            <label for="email" style="font-size: .7rem; font-weight: bold;">
                <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
                <span *ngIf="manuallyPicked && maxCountReached">
                    We recommend selecting a maximum of 12 columns for a cleaner and more readable PDF
                </span>
            </label>
        </div>

        <div class="row " style="margin:10px 10px 7% 10px;">
            <div class="col-md-12" *ngIf="selectedColumns.length">
                <div><label for="email">Selected Column(s)</label></div>
                <textarea id="selectedValuesTextarea" class="input-filed-textarea"
                    style="margin-top: 8px; cursor: not-allowed;" rows="4" cols="50" [disabled]="true"
                    [(ngModel)]="selectedColumnsAsString"></textarea>
            </div>

            <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
                <div class="col-md-6" *ngIf="!isForExcel">
                    <label for="radio">PDF Page Size</label>
                    <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
                        <mat-radio-button *ngFor="let data of pdfPageSizes"
                            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="col-md-6" style="margin-top: 1.5%;">
                    <label for="toggle">Pick Columns Manually?</label>&nbsp;
                    <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked"
                        id="toggle">
                        <ng-container *ngIf="manuallyPicked; else no">
                            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                        </ng-container>
                        <ng-template #no>
                            <span style="color: red;">No</span>
                        </ng-template>
                    </mat-slide-toggle>
                </div>
            </div>

            <div class="row mt-3" *ngIf="manuallyPicked">
                <div class="col-md-12">
                    <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
                    <mat-select matInput multiple placeholder="Select" #columns [(ngModel)]="selectedColumns"
                        (closed)="columnSearchText=''" (click)="focusSearch('focus-column-search')">
                        <input type="search" id="focus-column-search" class="dropdownsearchstyle"
                            [(ngModel)]="columnSearchText" matInput placeholder="search">
                        <div class="select-all">
                            <mat-checkbox [(ngModel)]="isAllColumns" (change)="toggleAllSelection('columns')">
                                Select All</mat-checkbox>
                        </div>
                        <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : columnSearchText"
                            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                    <!-- <ng-multiselect-dropdown class="multiselect-container" style="position: absolute; width: 80%;"
                        [(ngModel)]="selectedColumns" [settings]="multiSelectDropdownSetting" [data]="excelPdf.dropDown"
                        (onSelect)="onSelect()" (onDeSelect)="onSelect()" (onSelectAll)="onSelectAll($event)"
                        (onDeSelectAll)="onDeSelectAll($event)">
                    </ng-multiselect-dropdown> -->
                </div>
            </div>

            <div class="row mt-3"  *ngIf="!isForExcel">
                <div class="col-md-12">
                    <div><label for="email">Select Footer</label><span class="mandatory-symbol">*</span></div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
                        (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-column-search')">
                        <input type="search" id="focus-column-search" class="dropdownsearchstyle"
                            [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">
                        <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                            [value]="item.valueExp" (onSelectionChange)="onReportFooterSelect($event,item)">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <!-- <div class="row justify-content-md-center">
                <div class="col-sm-4">
                    <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
                </div>
                <div class="col-sm-8">
                    <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
                        (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')">
                        <input type="search" id="focus-footer-search" class="dropdownsearchstyle"
                            [(ngModel)]="pdfDetailSearchText" matInput placeholder="search">

                        <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
                            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>
            </div> -->
            <div class="row justify-content-md-center"  *ngIf="!isForExcel && checkAuVw">
                <div class="col-sm-4">
                    <label for="email">Is Save Report?</label>
                </div>
                <div class="col-sm-8">
                    <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
                        <ng-container *ngIf="isSaveReport; else noisSaveReport">
                            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                        </ng-container>
                        <ng-template #noisSaveReport>
                            <span style="color: red;">No</span>
                        </ng-template>
                    </mat-slide-toggle>
                </div>
            </div>
            <div class="row justify-content-md-center" *ngIf="isSaveReport">
                <div class="col-sm-4">
                    <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
                </div>
                <div class="col-sm-8">
                    <input type="text" class="input-filed-continers" [(ngModel)]="reportName"
                        [ngStyle]="{'border': isReportNameEmpty ? '1px solid red' : '1px solid black'}"
                        (input)="isReportNameEmpty = false">
                </div>
            </div>

        </div>

        <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
            <button mat-stroked-button class="addButton"
                (click)="generateReport(isForExcel ? 'Excel' : 'Pdf', excelPdf.reportType)">
                <i class="fa fa-file-excel-o"></i> Generate
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </ng-template>
</div>